import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Crown, CrownRequest, CrownResponse } from './types'
import { RequestError } from '../../../../shared/errorResponse'

const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'updatedAt' || item[0] === 'createdAt') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      } else if (item[0] === 'transactionId') {
        return ['id', item[1]?.toLowerCase()]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const crownsListMounted = createEvent<CrownRequest>()

export const setCrownsRequestError = createEvent<RequestError>()

export const getCrowns = fx<CrownRequest, CrownResponse>({
  method: 'GET',
  url: `/giftshop/history_operation`,
})

export const $crowns = restore<Crown[]>(
  getCrowns.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfCrowns = restore(
  getCrowns.doneData.map((a) => a.body.total),
  0,
)

export const $errorCrownsRequest = restore(setCrownsRequestError, {
  message: '',
  code: 0,
})

sample({
  clock: crownsListMounted,
  fn: ({ clientId, limit, page, order, filters }) => {
    const query = {
      page: String(page),
      limit: String(limit),
      order,
      where: JSON.stringify({
        clientId,
        ...(filters ?? {}),
      }),
    }
    return { query }
  },
  target: getCrowns,
})

sample({
  clock: getCrowns.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setCrownsRequestError],
})
